import React from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';

const Component = ({spot, latitude, longitude, menu, draggable=false, option}) => {

  const getIcon = (spot) => {

    // デフォルト
    let icon = menu2icon["vis_87_road"];

    const target = spot["管理区分"];

    if (target == "河川") {
      icon = menu2icon["vis_87_river"];
    } else if (target == "ダム") {
      icon = menu2icon["vis_87_dam"];
    } else if (target == "海岸") {
      icon = menu2icon["vis_87_kaigan"];
    } else if (target == "港湾") {
      icon = menu2icon["vis_87_kouwan"];
    } else if (target == "公園") {
      icon = menu2icon["vis_87_park"];
    } else if (target == "砂防") {
      icon = menu2icon["vis_87_sabou"];
    } else if (target == "ため池") {
        icon = menu2icon["vis_87_tameike"];
    }
    
    return new L.Icon({
      iconUrl: icon,
      iconRetinaUrl: icon,
      iconSize: [35, 35],
      iconAnchor: [17, 23],
      popupAnchor: [0, -50]
    })

  };
  
  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (menu, spot) => {

    let ret = []
    
    ret.push(<dl className='dl-list is-modal-spot'><dt>No.</dt><dd>{spot["No."]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>カメラ名</dt><dd>{spot["カメラ名"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>住所</dt><dd>{spot["住所"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{spot["緯度"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{spot["経度"]}</dd></dl>)
    if (!spot["リアル画像URL"]) {
      ret.push(<dl className='dl-list is-modal-spot'><dt>公開URL</dt><dd>{ spot["公開URL"].includes('http') && <a href={spot["公開URL"]} target={"_blank"}>{spot["公開URL"]}</a>}</dd></dl>)
    }
    ret.push(<dl className='dl-list is-modal-spot'><dt>所管</dt><dd>{spot["所管"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>管理区分</dt><dd>{spot["管理区分"]}</dd></dl>)
    if (spot["リアル画像URL"] || spot["平時画像ファイル名"]) {
      ret.push(
        <table style={{width: '100%', borderCollapse: 'collapse', marginTop: '5px'}}>
          <tbody>
            <tr>
              {spot["リアル画像URL"] && (
                <td style={{textAlign: 'center', verticalAlign: 'top', padding: '5px'}}>
                  <img src={spot["リアル画像URL"]} alt="リアルタイムの画像" style={{maxWidth: '100%'}} />
                  <div style={{marginTop: '3px', fontWeight: 'bold'}}>現在</div>
                </td>
              )}
              {spot["平時画像ファイル名"] && (
                <td style={{textAlign: 'center', verticalAlign: 'top', padding: '5px'}}>
                  <img src={`${process.env.REACT_APP_VIS_87_IMAGE_BASE_URL}${spot["平時画像ファイル名"]}`} alt="平時の画像" style={{maxWidth: '100%'}} />
                  <div style={{marginTop: '3px', fontWeight: 'bold'}}>平時</div>
                </td>
              )}
            </tr>
          </tbody>
        </table>
      )
    }

    return ret

  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <style>{`.leaflet-popup.vis_87 .leaflet-popup-content-wrapper { width: 600px; }`}</style>
        <Marker
          position={[latitude, longitude]}
          icon={getIcon(spot)}
        >
          <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={750} maxWidth={750} className="vis_87" closeOnClick>
            {
              handleSpotData(menu, spot)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
